import useCurrencyDisplay from "@casino/legacy/client/hooks/currency/useCurrencyDisplay";
import type { BalanceFragment } from "@workspace/casino_core/queries/UserBalanceQuery";

type Args = {
  balance?: BalanceFragment;
};

const useDisplayAmount = ({ balance }: Args) => {
  const { currency, totalBalance = 0 } = balance ?? {};
  const displayAmount = useCurrencyDisplay(totalBalance, {
    currency: currency as CashierCurrency,
  });
  return displayAmount;
};

export default useDisplayAmount;
